module.exports = __webpack_public_path__ + "img/downloaded-document-active.92048f5c.svg";